export const decodeAll = (text: string): string => {
  let prev
  let current = text

  do {
    prev = current
    try {
      current = decodeURIComponent(current)
    } catch {
      break // stop if malformed encoding
    }
  } while (current !== prev)

  return current
}
